import { areArraysEquivalent } from '../../../utils/equivalence-utils';
import { SeatSelectionRuleName } from '../types/seat-selection-rule-name';
export function getSeatSelectionRulesForState(rules, data, selectedSeats) {
    const selectedSeatIds = selectedSeats.map(s => s.id);
    if (areArraysEquivalent(data.reservedSeatIds, selectedSeatIds)) {
        // If seats were auto allocated, they are exempt from all rules,
        // except `MustRespectSeatSelectionLimits`
        return rules.filter(rule => rule.name === SeatSelectionRuleName.MustRespectSeatSelectionLimits);
    }
    return rules;
}
//# sourceMappingURL=get-seat-selection-rules-for-state.js.map